import { IBagValueItem } from '@/modules/bags/ts';
import { HTMLAttributes, ReactNode } from 'react';
import { WarehouseBagBunkerTemplate } from './bunker';
import { WarehouseBagSleeveTemplate } from './sleeve';

export function WarehouseBagTemplate(props: IWarehouseBagTemplateProps) {
  return props.type === 'sleeve' ? (
    <WarehouseBagSleeveTemplate {...props} />
  ) : (
    <WarehouseBagBunkerTemplate {...props} />
  );
}

export interface IWarehouseBagTemplateProps extends HTMLAttributes<HTMLDivElement> {
  image: ReactNode;
  borderColor: string;
  backgroundColor: string;
  cultureName: string;
  sleeveId?: string;
  attention?: boolean;
  params: ReactNode | ReactNode[];
  filled?: string;
  mixed?: boolean;
  actions?: ReactNode;
  weight?: number;
  type: 'sleeve' | 'bunker';
  resevedWeight: number;
  values?: IBagValueItem[];
}
